import { render, staticRenderFns } from "./czOther.vue?vue&type=template&id=db8a8fb0&scoped=true&"
import script from "./czOther.vue?vue&type=script&lang=js&"
export * from "./czOther.vue?vue&type=script&lang=js&"
import style0 from "./czOther.vue?vue&type=style&index=0&id=db8a8fb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8a8fb0",
  null
  
)

export default component.exports